import { render, staticRenderFns } from "./ArgoNotificationSnackbar.vue?vue&type=template&id=424b7a96&scoped=true&"
import script from "./ArgoNotificationSnackbar.vue?vue&type=script&lang=ts&"
export * from "./ArgoNotificationSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b7a96",
  null
  
)

export default component.exports